import React, { useEffect, useState } from "react";
import LinkToDocIcon from "../../assets/images/icons/LinkToDocIcon";
import LinkToTaskIcon from "../../assets/images/icons/LinkToTaskIcon";
import LinkToNotesIcon from "../../assets/images/icons/LinkToNotesIcon";
import { SearchIcon } from "lucide-react";
import ActiveInactiveLink from "../../assets/images/icons/ActiveInactiveLink";
import { getCompanyId, getOrganizationId, getUserId, getUserToken } from "../../utils/utilityFunctions/localServices";
import CustomDrawer from "../UniversalComponents/CustomDrawer";
import LogoutIcon from "@mui/icons-material/Logout";
import moment from "moment";
import { getAllTasks, unlinkTasks, getLinkedTasks, linkTasks } from "../../utils/api/taskApi";
import {
  useLazyFetchCustomerDocumentDataQuery,
  useLazyFetchCustomerNotesTableDataQuery,
  useLazyFetchLinkingDataQuery,
} from "../../utils/customer/customerTaskTable";
import { Avatar, CircularProgress } from "@mui/material";

import { ReactComponent as BackIcon } from "../../assets/images/icons/BackIcon.svg";
import { ReactComponent as AddBlueBorderIcon } from "../../assets/images/icons/AddBlueBorderIcon.svg";
// import { ReactComponent as LinkMenu } from "../../assets/images/linkMenu.svg";
import { ReactComponent as CrossIcon } from "../../assets/images/addTaskCrosIcn.svg";
import { ReactComponent as NotConnectedPlug } from "../../assets/images/NotConnectedPlug.svg";
import { ReactComponent as NoLinkTask } from "../../assets/images/NoLinkTask.svg";
import { ReactComponent as NoDocumentLink } from "../../assets/images/NoDocumentsLink.svg";

// TASK LIST ICONS
import { ReactComponent as PhoneIcon } from "../../assets/images/phone.svg";
import { ReactComponent as FollowUp } from "../../assets/images/icons/FollowUpIcon.svg";
import { ReactComponent as AppointmentIcon } from "../../assets/images/icons/AppointmentIcon.svg";
import { ReactComponent as MeetingIcon } from "../../assets/images/icons/MeetingIcon.svg";
import { ReactComponent as TaskIcon } from "../../assets/images/icons/TaskIcon.svg";

// FOLDER LIST ICONS
import { ReactComponent as FolderIcon } from "../../assets/images/icons/FolderIcon.svg";
import { ReactComponent as OfficeWordDocument } from "../../assets/images/icons/OfficeWordDocument.svg";
import { ReactComponent as PictureIcon } from "../../assets/images/icons/PictureIcon.svg";
import { ReactComponent as OfficeExcelicon } from "../../assets/images/icons/OfficeExcelicon.svg";
import { ReactComponent as PdfIcon } from "../../assets/images/icons/FileIcon_pdf.svg";
// import { ReactComponent as OfficePowerPoint } from "../../assets/images/icons/OfficePowerPoint.svg";

// import ActiveInactiveOption from "../../assets/images/icons/ActiveInactiveOption";
import LinkColorOnActive from "../../assets/images/icons/LinkColorOnActive";
import { useDispatch } from "react-redux";
import { pushAlert } from "../../utils/alertSlice";
import ToolTipComponent from "../UniversalComponents/ToolTipComponent";
import ExpandableNoteBody from "./ExpandableNoteBody";
import AddButton from "../UniversalComponents/AddButton";
import MotionSearchBox from "../UniversalComponents/MotionSearchBox";
import LinkedTaskCard from "./LinkedTaskCard";
import LinkedDocsCard from "./LinkedDocsCard";
import Loader from "../UniversalComponents/Loader";
import LoaderWrapper from "../UniversalComponents/CustomLoader";
import { ReactComponent as DocumentLink } from "../../assets/images/icons/documentLink.svg";
import ExpandableRecord from "./ExpandableRecord";
import { set } from "date-fns";
import { hideLoader, showLoader } from "../../utils/loaderSlice";

const LinkedDrawer = ({ open, onClose, data, taskId, parentType, selectedCustomer, subDrawer }) => {
  const dispatch = useDispatch();

  const [activeTab, setActiveTab] = useState("document");
  // const [linkedRows, setLinkedRows] = useState(new Set());
  const [isExpanded, setIsExpanded] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 540);
  const [isAddButtonActive, setIsAddButtonActive] = useState(false);

  const [isApiLoading, setIsApiLoading] = useState(false);
  // const [selectedLinks, setSelectedLinks] = useState([]);
  const [loading, setLoading] = useState(false);

  const [documentList, setDocumentList] = useState([]);
  const [taskList, setTaskList] = useState([]);
  const [notelist, setNoteList] = useState([]);

  const [linkedDocumentList, setLinkedDocumentList] = useState([]);
  const [linkedTaskList, setLinkedTaskList] = useState([]);
  const [linkedNotelist, setLinkedNoteList] = useState([]);
  const [linkedListsCount, setLinkedListsCount] = useState({ document: 0, task: 0, notes: 0 });

  const [linkingList, setLinkingList] = useState([]);
  // const [subject, setSubject] = useState(data?.subject || "");

  const [expanded, setExpanded] = useState(false);
  const [isReadmoreActive, setIsReadmoreActive] = useState(false);

  const isLoading = false;

  const [fetchCustomerDocumentData, { refetch: refetchAllDocumentData }] = useLazyFetchCustomerDocumentDataQuery();

  const [fetchCustomerNotesTableData, { refetch: refetchAllNotesData }] = useLazyFetchCustomerNotesTableDataQuery({
    customerId: selectedCustomer?.customer_id || data.customer_id,
  });

  const [
    getLinkingTask,
    {
      data: taskLinkingData,
      isLoading: isTaskLinkingDataLoading,
      isError: isTaskLinkingDataError,
      isSuccess: isTaskLinkingDataSuccess,
      error: taskLinkingDataError,
    },
  ] = useLazyFetchLinkingDataQuery();

  useEffect(() => {
    //loading
    if (isTaskLinkingDataLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    //try block
    if (isTaskLinkingDataSuccess) {
      dispatch(
        pushAlert({
          message: taskLinkingData?.message,
          type: taskLinkingData?.success || taskLinkingData?.success ? "success" : "danger", // success is not comming form backend
          visible: true,
        })
      );
      setLinkingList(taskLinkingData?.data ?? []);
      setActiveTab(taskLinkingData?.file_type);
    }

    // catch block
    if (isTaskLinkingDataError) {
      dispatch(pushAlert({ message: taskLinkingDataError?.data?.message, type: "danger", visible: true }));
    }
  }, [isTaskLinkingDataLoading, isTaskLinkingDataSuccess, isTaskLinkingDataError, taskLinkingData?.data]);

  const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  };

  const highlightText = (text, query) => {
    console.log(text, "text");

    if (!text || !query) return text || "";

    const textStr = String(text);
    const words = query.trim().split(/\s+/).filter(Boolean);

    try {
      const regex = new RegExp(`(${words.map(escapeRegExp).join("|")})`, "gi");
      const parts = textStr.split(regex);
      return parts.map((part, index) =>
        regex.test(part) ? (
          <span
            key={index}
            style={{ all: "unset", backgroundColor: "#fde68a" }} // overrides text-transform: capitalize
          >
            {part}
          </span>
        ) : (
          part
        )
      );
    } catch (error) {
      return textStr;
    }
  };

  // ICON LIST FOR TABS
  const iconsData = [
    {
      IconComponent: LinkToDocIcon,
      count: 5,
      tabName: "document",
    },
    {
      IconComponent: LinkToTaskIcon,
      count: 9,
      tabName: "records",
    },
    {
      IconComponent: LinkToNotesIcon,
      count: 5,
      tabName: "notes",
    },
  ];
  const taskIconList = [
    {
      value: "follow up",
      icon: <FollowUp />,
    },
    {
      value: "appointment",
      icon: <AppointmentIcon />,
    },
    {
      value: "meeting",
      icon: <MeetingIcon />,
    },
    {
      value: "task",
      icon: <TaskIcon />,
    },
    {
      value: "call",
      icon: <PhoneIcon />,
    },
  ];
  const folderIconList = [
    {
      value: ["folder", "subfolder"],
      icon: <FolderIcon />,
    },
    {
      value: ["file", ""],
      icon: <OfficeWordDocument />,
    },
    {
      value: ["file", "image", "jpg", "jpeg", "png", "webp", "gif", "svg"],
      icon: <PictureIcon />,
    },
    {
      value: ["file", "xlsx", "xls", "csv"],
      icon: <OfficeExcelicon />,
    },
    {
      value: ["pdf"],
      icon: <PdfIcon />,
    },
  ];

  // For Search by text input functionality
  const filterArrayOverKey = (arr, key, value) => {
    return arr?.filter((item) => item[key]?.toLowerCase()?.includes(value?.toLowerCase()));
  };

  const getNestedValue = (obj, key) => {
    try {
      return key
        .replace(/\[(\d+)\]/g, ".$1") // convert [0] to .0
        .split(".")
        .reduce((acc, part) => acc?.[part], obj);
    } catch {
      return undefined;
    }
  };

  const filterArrayOverKeys = (arr, keys = [], value = "") => {
    if (!Array.isArray(arr) || !Array.isArray(keys) || !value) return arr;

    const lowerValue = value.toLowerCase();

    return arr.filter((item) =>
      keys.some((key) => {
        const val = getNestedValue(item, key);
        return typeof val === "string" && val.toLowerCase().includes(lowerValue);
      })
    );
  };

  // // Return name initials for 1 and 2 names strings input. (Eg. "John Doe" => "JD", "John" => "J")
  const createAvatarInitials = (name) => {
    function stringToColor(string) {
      let hash = 0;
      let i;
      /* eslint-disable no-bitwise */
      for (i = 0; i < string?.length; i += 1) {
        hash = string?.charCodeAt(i) + ((hash << 5) - hash);
      }
      let color = "#";
      for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value?.toString(16)}`.slice(-2);
      }
      /* eslint-enable no-bitwise */
      return color;
    }

    const nameParts = name.split(" ");
    const initials = nameParts.length > 1 ? `${nameParts[0][0]}${nameParts[1][0]}` : nameParts[0][0]; // If only one name, take the first character

    return {
      sx: {
        bgcolor: stringToColor(name),
      },
      children: initials?.toUpperCase(),
    };
  };

  useEffect(() => {
    if (taskId) {
      getLinkingTask({ taskId });
    }
  }, [taskId]);

  return (
    <CustomDrawer
      open={open}
      onClose={onClose}
      subDrawer={subDrawer}
      headerText={`Linked ${activeTab}`}

      // headerAction={
      //   <AddButton
      //     isActive={isAddButtonActive}
      //     activeText={"Back"}
      //     onClick={() => setIsAddButtonActive((prev) => !prev)}
      //   />
      // }
    >
      <div className="flex flex-col h-full">
        {/* TABS SECTION */}
        {false && (
          <div className="left-buttons flex py-1 gap-1">
            {iconsData.map(({ IconComponent, count, tabName }, index) => {
              const isActive = activeTab === tabName;

              return (
                <ToolTipComponent key={index} text={tabName.charAt(0).toUpperCase() + tabName.slice(1)}>
                  <button className="group px-3 relative" onClick={() => setActiveTab(tabName)}>
                    <span
                      className={`
                      absolute top-[-4px] right-1.5 text-[10px] rounded-full min-w-4 h-4 p-1 
                      flex justify-center items-center 
                      text-white transition-colors duration-200
                      ${isActive ? "bg-[#EE2727]" : "bg-[#767676] group-hover:bg-[#313F51]"}
                    `}
                    >
                      {linkedListsCount[tabName?.toLowerCase()]}
                    </span>

                    {/* This will let the icon detect hover via Tailwind classes */}
                    <IconComponent
                      isActive={isActive}
                      className={`transition-colors duration-200 ${
                        isActive ? "text-[#EE2727]" : "text-[#767676] group-hover:text-[#505E70]"
                      }`}
                    />
                  </button>
                </ToolTipComponent>
              );
            })}
          </div>
        )}

        {/* <div className="flex justify-between py-2 border-BECBD3 gap-2">
          <MotionSearchBox
            isSearchActive={isExpanded}
            setIsSearchActive={setIsExpanded}
            searchText={searchText}
            setSearchText={setSearchText}
            placeholder={"Search..."}
            expanded
          />
        </div> */}

        {/* TABS BODY */}
        <div className="grow min-h-0 border flex flex-col  bg-white rounded-md ">
          <div className="px-3  capitalize text-base font-medium text-[#464646]">{/* {activeTab} */}</div>
          <LoaderWrapper isLoading={isApiLoading}>
            {activeTab === "document" && (
              <div className="flex flex-col grow min-h-0 overflow-y-auto thinscrollbar">
                {linkingList?.length > 0 ? (
                  linkingList?.map((info, key) => (
                    <LinkedDocsCard
                      info={info}
                      key={key}
                      // handleUnlinkDocument={handleUnlinkDocument}
                      // handleLinkDocument={handleLinkDocument}
                      highlightText={highlightText}
                      searchText={searchText}
                      folderIconList={folderIconList}
                    />
                  ))
                ) : (
                  <div className="flex h-full flex-col items-center justify-center gap-4">
                    <DocumentLink />
                    <p className="text-[#969BA9] ">No {activeTab} linked to this task..</p>
                    {/* <button
                    onClick={() => {
                      setIsAddButtonActive((prev) => !prev);
                    }}
                    className="flex gap-2 shadow-[0px_0px_5px_1px_rgba(0,_0,_0,_0.1)] py-2 px-10 rounded-full"
                  >
                    <span>+</span>
                    <span>Add {activeTab}</span>
                    
                  </button> */}
                  </div>
                )}
              </div>
            )}

            {activeTab === "records" && (
              <div className="flex flex-col grow min-h-0 overflow-y-auto thinscrollbar">
                {linkingList?.length > 0 ? (
                  linkingList?.map((info, key) => {
                    return (
                      <ExpandableRecord
                        type={"unlink"}
                        setIsReadmoreActive={setIsReadmoreActive}
                        isReadmoreActive={isReadmoreActive}
                        info={info}
                        key={key}
                        createAvatarInitials={createAvatarInitials}
                        // handleLink={handleLink}
                        // handleUnlink={handleUnlink}
                        searchText={searchText}
                        highlightText={highlightText}
                      />
                    );
                  })
                ) : (
                  <div className="flex h-full flex-col items-center justify-center gap-4">
                    <NotConnectedPlug />
                    <p className="text-[#969BA9] ">No {activeTab} linked to this task.</p>
                    {/* <button
                        onClick={() => {
                          setIsAddButtonActive((prev) => !prev);
                        }}
                        className="flex gap-2 shadow-[0px_0px_5px_1px_rgba(0,_0,_0,_0.1)] py-2 px-10 rounded-full"
                      >
                        <span>+</span>
                        <span>Add {activeTab}</span>
                      </button> */}
                  </div>
                )}
              </div>
            )}

            {activeTab === "notes" && (
              <div className="flex flex-col grow min-h-0 overflow-y-auto thinscrollbar ">
                {linkingList?.length > 0 ? (
                  linkingList?.map((info, key) => {
                    return (
                      <ExpandableNoteBody
                        type={"unlink"}
                        setIsReadmoreActive={setIsReadmoreActive}
                        isReadmoreActive={isReadmoreActive}
                        info={info}
                        key={key}
                        createAvatarInitials={createAvatarInitials}
                        // handleLink={handleLink}
                        // handleUnlink={handleUnlink}
                        searchText={searchText}
                        highlightText={highlightText}
                      />
                    );
                  })
                ) : (
                  <div className="flex h-full flex-col items-center justify-center gap-4">
                    <NotConnectedPlug />
                    <p className="text-[#969BA9] ">No {activeTab} linked to this task.</p>
                    {/* <button
                        onClick={() => {
                          setIsAddButtonActive((prev) => !prev);
                        }}
                        className="flex gap-2 shadow-[0px_0px_5px_1px_rgba(0,_0,_0,_0.1)] py-2 px-10 rounded-full"
                      >
                        <span>+</span>
                        <span>Add {activeTab}</span>
                      </button> */}
                  </div>
                )}
              </div>
            )}
          </LoaderWrapper>
        </div>
      </div>
    </CustomDrawer>
  );
};

export default LinkedDrawer;
